import { render, staticRenderFns } from "./ListCustomerCards.vue?vue&type=template&id=1894d295&scoped=true&"
import script from "./ListCustomerCards.vue?vue&type=script&lang=js&"
export * from "./ListCustomerCards.vue?vue&type=script&lang=js&"
import style0 from "./ListCustomerCards.vue?vue&type=style&index=0&id=1894d295&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1894d295",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VIcon,VList,VRow,VTextField})
